import { Component, Input, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-yandex-ad',
  template: '<div [style]="safeCss(this.style)"><div id="yandex_rtb_{{blockId}}"></div></div>',
})
export class YandexAdComponent implements AfterViewInit {
  @Input() blockId: string;
  @Input() style: string;

  constructor(private doms: DomSanitizer) {}

  safeCss(style) {
    return this.doms.bypassSecurityTrustStyle(style);
  }

  ngAfterViewInit() {
    // @ts-ignore
    window.yaContextCb.push(() => {
      // @ts-ignore
      Ya.Context.AdvManager.render({
        blockId: this.blockId,
        renderTo: 'yandex_rtb_' + this.blockId
      });
    });
  }

}
// @Component({
  // selector: 'app-yandex-ad',
  // template: '<div style="height: 250px; width: 300px; margin-bottom: 30px;" ><div id="yandex_rtb_R-A-7007263-1"></div></div>',
// })
// export class YandexAdComponent implements AfterViewInit {

  // ngAfterViewInit() {
    // // @ts-ignore
    // window.yaContextCb.push(() => {
      // // @ts-ignore
      // Ya.Context.AdvManager.render({
        // blockId: 'R-A-7007263-1',
        // renderTo: 'yandex_rtb_R-A-7007263-1'
      // });
    // });
  // }

// }
